<!--
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2022-09-16 14:26:25
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2023-06-21 10:23:25
 * @FilePath: \exevnt\src\views\rain\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div style="width: 100vw; height: 90vh; position: relative">
    <div class="maptitle">
      <div class="maptitleText">
        <div style="height: 30px; text-align: center; font-weight: 700">全国{{ name }}日数分布图</div>
        <div
          style="height: 30px; text-align: center; font-size: 12px"
        >{{ NewStartTime }}至{{ NeweEdtTime }}</div>
      </div>
    </div>
    <div style="width: 100vw; height: 90vh;display:flex;position: relative;">
      <div id="map">
        <Legend :type="type"></Legend>
      </div>
      <div
        style="width:8%;height:100vh;background-color:#32709F;border: 1px solid rgb(255, 255, 255); "
      >
        <el-menu
          :default-active="assessType"
          class="el-menu-vertical-demo"
          background-color="#32709F"
          text-color="#fff"
          active-text-color="#409EFF"
          @select="sliodSelect"
        >
          <el-menu-item index="暴露度">
            <span slot="title">暴露度</span>
          </el-menu-item>
          <el-menu-item index="脆弱性">
            <span slot="title">脆弱性</span>
          </el-menu-item>
          <el-menu-item index="致灾因子危险性">
            <span slot="title">致灾因子危险性</span>
          </el-menu-item>
          <el-menu-item index="综合风险">
            <span slot="title">综合风险</span>
          </el-menu-item>
        </el-menu>
      </div>
      <div class="controller" v-show="PanleShowHidden" v-loading="PanelLoading">
        <div class="controller_title">
          <div
            style="
            width: 100%;
            text-align: center;
            line-height: 30px;
            color: white;
            font-weight: 600;
          "
          >查询面板</div>
          <div
            style="
            width: 30px;
            height: 30px;
            position: absolute;
            right: 5px;
            top: 0;
          "
            @click="close"
          >
            <img src="../../assets/images/close.png" alt style="width: 100%; height: 100%" />
          </div>
        </div>
        <div class="controller-body">
          <div style="display: flex; margin-top: 15px">
            <div>起止时间:</div>
            <div style="width: 300px; margin-left: 15px">
              <el-date-picker
                :append-to-body="false"
                style="width: 145px"
                size="mini"
                type="date"
                value-format="yyyyMMddHHmmss"
                v-model="startyear"
                @change="startyearChange"
              ></el-date-picker>
              <el-date-picker
                :append-to-body="false"
                style="width: 145px; margin-left: 10px"
                size="mini"
                type="date"
                value-format="yyyyMMddHHmmss"
                v-model="endyear"
                @change="endyearChange"
              ></el-date-picker>
            </div>
          </div>
          <div style="display: flex; margin-top: 15px">
            <div>数据类型:</div>
            <div style="width: 300px; margin-left: 15px">
              <el-radio-group v-model="radio4" size="mini">
                <el-radio-button label="BCC"></el-radio-button>
                <el-radio-button label="CCCMA"></el-radio-button>
                <el-radio-button label="CNRM2"></el-radio-button>
                <el-radio-button label="GFDL"></el-radio-button>
              </el-radio-group>
            </div>
          </div>
          <div style="display: flex; margin-top: 15px">
            <div>区域选择:</div>
            <div style="width: 400px; margin-left: 15px">
              <el-radio-group v-model="radio5" size="mini" @change="methodChange">
                <el-radio-button label="全国"></el-radio-button>
                <el-radio-button label="省"></el-radio-button>
                <el-radio-button label="市" v-show="CityShow"></el-radio-button>
                <el-radio-button label="县" v-show="CountyShow"></el-radio-button>
                <el-radio-button label="矩形"></el-radio-button>
                <el-radio-button label="任意区域"></el-radio-button>
                <el-radio-button label="点"></el-radio-button>
              </el-radio-group>
            </div>
          </div>
          <div
            style="display: flex; margin-top: 15px"
            v-show="radio5 == '省' || radio5 == '市' || radio5 == '县'"
          >
            <div>行政区:</div>
            <div style="width: 420px; margin-left: 15px">
              <el-select
                value-key="center"
                transfer="true"
                :popper-append-to-body="false"
                v-model="pro"
                placeholder="请选择省"
                size="mini"
                style="width: 150px"
                @change="changePro"
              >
                <el-option
                  v-for="item in options2"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-select
                transfer="true"
                :popper-append-to-body="false"
                v-show="radio5 == '市' || radio5 == '县'"
                v-model="city"
                @change="changecity"
                placeholder="请选择市"
                size="mini"
                style="width: 150px"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-select
                transfer="true"
                :popper-append-to-body="false"
                v-model="county"
                v-show="radio5 == '县'"
                placeholder="请选择县"
                size="mini"
                style="width: 120px"
              >
                <el-option
                  v-for="item in options3"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div style="display: flex; margin-top: 15px">
            <el-button type="primary" size="mini" v-show="!ifArea" @click="query">查询</el-button>
            <el-button type="primary" size="mini" v-show="ifArea" @click="beginDraw">开启绘制</el-button>
          </div>
          <div>
            <Echarts :name="name"></Echarts>
          </div>
          <div>
            <Echarts2 :name="name"></Echarts2>
          </div>
        </div>
      </div>
    </div>

    <!-- <div
      style="
        width: 50px;
        height: 50px;
        position: absolute;
        background-color: white;
        right: 20px;
        top: 30px;
        z-index: 9999;
        text-align: center;
        line-height: 40px;
        border: 2px solid gray;
        border-radius: 5px;
      "
      v-show="!PanleShowHidden"
      @click="Show"
    >
      <img
        src="../../assets/images/panel.png"
        alt
        style="
          width: 80%;
          height: 80%;
          display: inline-block;
          vertical-align: middle;
        "
      />
    </div>-->
    <!-- <Legend :type="type"></Legend> -->
  </div>
</template>

<script>
import { MapCreate, legendColor } from "../../map/mapImport.js";
import Echarts from "../../components/Echarts.vue";
import Echarts2 from "../../components/Echarts2.vue";
import Legend from "../../components/Legend.vue";
import axios from "axios";
import moment from "moment";
// import MyArea from "../../assets/areaData/index.js";
import { show, hide } from "../../../public/loading.js";

// import moment from "moment";
export default {
  data() {
    return {
      assessType: "暴露度",
      startTime: "1961-01-01",
      endtTime: "1961-01-05",
      cityPlygonList: null,
      polygonGrounpList: [],
      polygonGrounp: null,
      type: "rain",
      name: "气候变化",
      tilePixelLayer: null,
      ifArea: false,
      map: null,
      radio4: "BCC",
      radio5: "全国",
      startyear: "19610101000000", //默认起始时间
      endyear: "19610105000000", // 默认结束时间
      city: "",
      pro: "",
      county: "",
      options: [
        {
          value: "成都",
          lable: "成都"
        }
      ],
      options3: [
        {
          value: "大邑县",
          lable: "大邑县"
        }
      ],
      options2: [],
      drawStartPrint: [],
      drawEndPrint: [],
      PanleShowHidden: true,
      tmprect: null,
      polygonsList: [],
      polygonlayer: null,
      printLaryer: null,
      citypolygonList: [],
      // PanelClose:true,
      // PanelShow:false,
      PanelLoading: false, //查询加载动画
      CityShow: false, //市的显示隐藏
      CountyShow: false //县的显示隐藏
    };
  },
  mounted() {
    this.map = new MapCreate();
    //   this.map.init();
    this.map.init();
    // this.showwMap();
  },
  created() {
    this.getAreaName("中国", "pro");
  },
  beforeDestroy() {
    // this.map.remove();
  },
  methods: {
    sliodSelect(e) {
      console.log(e);
      this.assessType = e;
    },
    // mycurrentSel(e) {
    //   console.log(e);
    // },
    changePro(e, index) {
      // let obj=this.companyOptions.find(item=>item.value===1)
      let cneter = this.options2.find(l => l.value == e).center;

      // this.map.flyToCneter(cneter.split(",").reverse(), 6);
      this.getAreaName(e, "city");
      this.county = "";
      // this.pro = "";
      this.city = "";
      this.CityShow = true;
    },
    changecity(e) {
      let cneter = this.options.find(l => l.value == e).center;
      // console.log(cneter);
      // this.map.flyToCneter(cneter.split(",").reverse(), 9);
      this.getAreaName(e, "county");
      this.county = "";
      // this.pro = "";
      // this.city = "";
      this.CountyShow = true;
    },
    getAreaName(data, type) {
      let t = this;
      t.PanelLoading = true;
      axios
        .get(
          `https://restapi.amap.com/v3/config/district?keywords=${data}&subdistrict=1&key=fec11a110bfded3b524f6a897d0c01b0&extensions=all`
        )
        .then(res => {
          // console.log(res.data.districts[0].adcode);
          if (this.cityPlygonList != null) {
            this.cityPlygonList.remove();
          }
          if (this.polygonGrounp != null) {
            this.polygonGrounp.clearLayers();
          }
          let list = [];
          let bounds = [];
          this.polygonGrounpList = [];
          list = res.data.districts[0].polyline.split("|");

          list.map(item => {
            // console.log(item);
            let newPoyList = [];

            item.split(";").map(e => {
              let data = e.split(",");
              newPoyList.push([Number(data[1]), Number(data[0])]);
            });
            // console.log(

            // );
            bounds.push(
              L.polygon(newPoyList, {
                color: "red",
                opacity: 1,
                fillColor: "#fff"
              }).getBounds()
            );
            this.polygonGrounpList.push(
              L.polygon(newPoyList, {
                color: "yellow",
                opacity: 1,
                fillColor: "#fff",
                weight: 5
              })
            );
          });
          if (res.data.districts[0].adcode != "100000") {
            this.polygonGrounp = L.layerGroup(this.polygonGrounpList).addTo(
              this.map.map
            );
          }
          this.map.map.fitBounds(bounds);
          if (res.data.districts[0].adcode != "100000") {
            axios
              .post(
                `http://47.108.55.246:7090/NccDataService/getAreaJson/${res.data.districts[0].adcode}`
              )
              .then(req => {
                if (req.data != undefined) {
                  const style = {
                    color: "#57606f", //线颜色
                    weight: 1, //线粗细
                    opacity: 1, //透明度
                    fillColor: "#fff", //区域填充颜色
                    fillOpacity: 0 //区域填充颜色的透明
                  };
                  this.cityPlygonList = L.geoJSON(req.data, {
                    style: style
                  }).addTo(this.map.map);
                }
              });
          }

          if (type == "pro") {
            this.options2 = [];

            // this.pro = res.data.districts[0].districts[0].name;
          } else if (type == "city") {
            this.options = [];
            // this.county = "";
            // this.city = res.data.districts[0].districts[0].name;
          } else if (type == "county") {
            this.options3 = [];
            // this.county = res.data.districts[0].districts[0].name;
          }
          // this.options2 = [];
          // let t = this;
          res.data.districts[0].districts.map(item => {
            // console.log({
            //   value: item.name,
            //   lable: item.name,
            //   center: item.center,
            // });
            if (type == "pro") {
              t.options2.push({
                value: item.name,
                lable: item.name,
                center: item.center
              });
            } else if (type == "city") {
              t.options.push({
                value: item.name,
                lable: item.name,
                center: item.center
              });
            } else if (type == "county") {
              t.options3.push({
                value: item.name,
                lable: item.name,
                center: item.center
              });
            }

            // this.options2.push(11);‘
          });
          // console.log(t.options2);
          this.PanelLoading = false;
        });
    },
    focus() {
      // console.log(1);
    },
    getCityList(data) {
      this.options = [];
      axios
        .get(
          `https://restapi.amap.com/v3/config/district?keywords=${data}&subdistrict=1&key=fec11a110bfded3b524f6a897d0c01b0&extensions=all`
        )
        .then(res => {
          // console.log(res);
          this.city = res.data.districts[0].districts[0].name;
          res.data.districts[0].districts.map(item => {
            this.options.push({
              value: item.name,
              lable: item.name,
              center: item.center
            });
          });
        });
    },
    getCounyList(data) {
      this.options3 = [];
      axios
        .get(
          `https://restapi.amap.com/v3/config/district?keywords=${data}&subdistrict=1&key=fec11a110bfded3b524f6a897d0c01b0&extensions=all`
        )
        .then(res => {
          // console.log(res);
          this.county = res.data.districts[0].districts[0].name;
          res.data.districts[0].districts.map(item => {
            this.options3.push({
              value: item.name,
              lable: item.name,
              center: item.center
            });
          });
        });
    },
    beginDraw() {
      if (this.radio5 == "矩形") {
        this.DrawRectangle();
      } else if (this.radio5 == "任意区域") {
        this.polygonsList = [];
        if (this.polygonlayer != null) {
          this.polygonlayer.remove();
        } else if (this.tmprect != null) {
          this.tmprect.remove();
        }
        this.drawPolygons();
      }
    },
    methodChange(e) {
      console.log(e, this.CityShow, this.CountyShow);
      if (e == "矩形" || e == "任意区域") {
        if (this.printLaryer != null) {
          this.printLaryer.remove();
        }
        this.map.map.off("click");
        this.ifArea = true;

        if (this.CityShow || this.CountyShow) {
          //判断市、县按钮是否存在，存在则隐藏
          this.CityShow = false;
          this.CountyShow = false;
        }
      } else if (e == "点") {
        this.darwPrint();
        this.ifArea = true;

        if (this.CityShow || this.CountyShow) {
          //判断市、县按钮是否存在，存在则隐藏
          this.CityShow = false;
          this.CountyShow = false;
        }
      } else if (e == "全国") {
        this.map.flyToCneter([34.32, 108.55], 4);
        this.ifArea = false;
        if (this.CityShow || this.CountyShow) {
          //判断市、县按钮是否存在，存在则隐藏
          this.CityShow = false;
          this.CountyShow = false;
        }
      } else if (e == "省") {
        this.ifArea = false;

        if (this.CityShow || this.CountyShow) {
          //判断市、县按钮是否存在，存在则隐藏
          this.CityShow = false;
          this.CountyShow = false;
        }
      } else if (e == "市") {
        // this.getCityList(this.pro);
        this.ifArea = false;
        if (this.CountyShow) {
          this.CountyShow = false;
        } //判断县按钮是否存在，存在则隐藏
      } else if (e == "县") {
        // this.getCounyList(this.city);
        this.ifArea = false;
      } else {
        this.ifArea = false;
      }
    },
    darwPrint() {
      this.map.map.on("click", e => {
        if (this.polygonlayer != null) {
          this.polygonlayer.remove();
        } else if (this.tmprect != null) {
          this.tmprect.remove();
        }
        if (this.printLaryer != null) {
          this.printLaryer.remove();
        }
        this.printLaryer = L.circleMarker([e.latlng.lat, e.latlng.lng], {
          radius: 5
        }).addTo(this.map.map);
      });
    },
    drawPolygons() {
      this.map.map.on("click", e => {
        // console.log(this.polygonsList);

        this.polygonsList.push([e.latlng.lat, e.latlng.lng]);
        this.map.map.on("mousemove", e => {
          // console.log(e);
          // console.log([e.latlng.lat, e.latlng.lng]);
          if (this.polygonlayer != null) {
            this.polygonlayer.remove();
          }
          this.polygonlayer = L.polygon(
            [
              ...JSON.parse(JSON.stringify(this.polygonsList)),
              [e.latlng.lat, e.latlng.lng]
            ],
            {
              color: "red"
            }
          ).addTo(this.map.map);
        });
        this.map.map.on("dblclick", e => {
          // console.log(e);
          if (this.polygonlayer != null) {
            this.polygonlayer.remove();
          }
          this.polygonsList.push([e.latlng.lat, e.latlng.lng]);
          this.polygonlayer = L.polygon(this.polygonsList, {
            color: "red"
          }).addTo(this.map.map);
          this.map.map.off("mousemove");
          this.map.map.off("click");
        });
        // this.polygonlayer = L.polygon(this.polygonsList, {
        //   color: "red",
        // }).addTo(this.map.map);
      });
    },
    DrawRectangle() {
      //矩形绘制
      // console.log(111);
      this.map.map.on("mousedown", e => {
        // console.log(e);
        this.map.map.dragging.disable();
        // console.log([e.latlng.lat, e.latlng.lng]);
        this.drawStartPrint = [e.latlng.lat, e.latlng.lng];
        this.map.map.on("mousemove", end => {
          // console.log([e.latlng.lat, e.latlng.lng]);
          if (this.tmprect != null) {
            this.tmprect.remove();
          }
          this.drawEndPrint = [end.latlng.lat, end.latlng.lng];
          this.tmprect = L.rectangle([this.drawStartPrint, this.drawEndPrint], {
            color: "#0077ff",
            weight: 2
          }).addTo(this.map.map);
        });
      });
      this.map.map.on("mouseup", e => {
        // console.log(e);
        this.map.map.off("mousemove");
      });
    },
    showwMap() {
      show();
      axios
        .get(
          `http://47.108.55.246:7080/SWDataservice/interface/v1/api?interfaceId=getNCCGridByPreHis&starttime=${this.startyear}&endtime=${this.endyear}`
        )
        .then(res => {
          // console.log(this.map.map.addLayer);
          // console.log(res.data.dataList[0].datas.split(","));
          if (this.tilePixelLayer != null) {
            console.log(12221);
            this.map.map.removeLayer(this.tilePixelLayer);
            this.tilePixelLayer == null;
            // return;
          }
          let data = JSON.parse(this.unzip(res.data[0].datas));
          // console.log(res.data.dataList[0].datas.split(","));
          this.tilePixelLayer = L.tilePixelLayer({
            newData: data.datas.split(","),
            data: data,
            gradient: legendColor[this.type]
          });
          this.map.map.addLayer(this.tilePixelLayer);
          hide();
        })
        .catch(() => {
          hide();
        });
    },
    query() {
      this.showwMap();
      // console.log(111);
    },
    startyearChange(e) {
      // console.log(e);
      // console.log(moment(new Date(e).getTime()).format("YYYY-MM-DD"));
      // this.startyear = e;
    },
    endyearChange(e) {
      // e = Number(e) + 1130000000;
      // console.log(String(e));
      // this.endyear =;
    },
    close() {
      this.PanleShowHidden = false;
    },
    Show() {
      this.PanleShowHidden = true;
    },
    //时间格式化
    timeFormat(timestamp) {
      var time = new Date(timestamp);
      var year = time.getFullYear();
      var month = time.getMonth() + 1;
      var date = time.getDate();
      var hours = time.getHours();
      var minutes = time.getMinutes();
      var seconds = time.getSeconds();
      return (
        year +
        "-" +
        this.addZero(month) +
        "-" +
        this.addZero(date) +
        " " +
        this.addZero(hours)
      );
      // + ':' + this.addZero(minutes) + ':' + this.addZero(seconds)
    },
    addZero(num) {
      return num < 10 ? "0" + num : num;
    }
  },
  components: { Echarts, Echarts2, Legend },

  computed: {
    NewStartTime() {
      let newValue = /(\d{4})(\d{2})(\d{2})/.exec(this.startyear);
      return `${newValue[1]}-${newValue[2]}-${newValue[3]}`;
    },
    NeweEdtTime() {
      let newValue = /(\d{4})(\d{2})(\d{2})/.exec(this.endyear);
      return `${newValue[1]}-${newValue[2]}-${newValue[3]}`;
    }
  },
  watch: {
    // startTime(newValue,oldValue){
    //   console.log(newValue,old)
    // },
    // NewendtTime(){
    // }
  }
};
</script>

<style scoped>
.maptitleText {
  width: 200px;
  height: 60px;
  background-color: rgb(243, 243, 243);
  margin: auto;
  position: relative;
  z-index: 9999;
  box-shadow: 1px 1px 5px 1px #7f8c8d;
  border-radius: 5px;
  padding: 5px;
}

.maptitle {
  width: 80vw;
  position: absolute;
  top: 15px;
  right: 0;
}

#map {
  width: 62%;
  height: 100%;
  position: absolute;
  z-index: 1;
  right: 0;
  border: 1px solid #274986;
}

.controller {
  height: 100%;
  width: 30%;
  background-color: rgb(255, 255, 255);
  /* position: absolute;
  top: 15px;
  right: 5px; */
  /* z-index: 9999; */
  /* box-shadow: 1px 1px 5px 1px black; */
  /* border-radius: 5px; */
  overflow: hidden;
  border: 1px solid #274986;
  font-size: 12px;
}

.controller_title {
  width: 100%;
  height: 30px;
  background-color: #274986;
}

.controller-body {
  width: 100%;
  padding: 0 15px;
  /* height: ; */
}

.el-picker-panel {
  z-index: 9999 !important;
}
.test1 {
  position: absolute;
  z-index: 9999;
}
</style>